export default __webpack_public_path__ + "static/media/it.08db2cd1.svg";